module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QRimg_main"
  }, [_c('div', {
    staticClass: "QRimg_body"
  }, [_c('div', {
    staticClass: "QRimg_head"
  }, [_c('span', {
    staticClass: "QRimg_text"
  }, [_vm._v("二维码")]), _vm._v(" "), _c('i', {
    staticClass: "QRimg_close",
    attrs: {
      "title": "关闭"
    },
    on: {
      "click": _vm.closeQR
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "image_title"
  }, [_vm._v(_vm._s(_vm.QRTitle))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.QRcodeImg,
      "alt": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0d458d54","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/base/QRcodePage.vue
// module id = 520
// module chunks = 1 2 3 4 5 6 7 8